// Copyright (c) 2017 Deere & Company

import {stripQuotes} from './strip-quotes';

export const getFileName = response => {

    let fileName;

    const contentDisposition = response.headers.get('content-disposition');

    if (contentDisposition.lastIndexOf('filename=') > -1) {

        fileName = stripQuotes(contentDisposition.substring(contentDisposition.lastIndexOf('filename=') + 9, contentDisposition.length));

    } else {

        fileName = 'no_filename_assigned';

    }

    return fileName;

};



// WEBPACK FOOTER //
// ./src/shared/services/get-file-name.js